import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'so-search-with-selector',
  templateUrl: './so-search-with-selector.component.html',
  styleUrl: './so-search-with-selector.component.scss'
})
export class SoSearchWithSelectorComponent {
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  
  @Input() placeholder: string = 'Buscar...';
  @Input() options: {value: string, label: string}[]  = [];

  @Output() valueChange = new EventEmitter<{ text: string; selected: { value: string; label: string } }>();

  inputValue: string = '';
  public selectedOption: { value: string, label: string } = this.options[0];

  ngOnInit(): void {
    if (this.options?.length > 0) {
      this.selectedOption = this.options[0];
    }
  }

  selectOption(option: { value: string; label: string }): void {
    if (this.selectedOption.value === option.value) {
    return;
  }
    this.selectedOption = option;
    this.clearInput();
  }

  doSearch(): void {
    if(this.inputValue.trim() === '') {
      return;
    }
    this.emitChange();
  }

   clearInput(): void {
    this.resetInput();
  }

  resetInput(): void {
    this.inputValue = '';
    this.emitChange();
    this.input.nativeElement.value = '';
    this.input.nativeElement.focus();
  }

  private emitChange(): void {
    this.valueChange.emit({
      text: this.inputValue,
      selected: this.selectedOption
    });
  }

  onKeyPress(event: KeyboardEvent): void {
    if (this.selectedOption.value === 'phone') {
      const allowedChars = /^[0-9]$/;
      if (!allowedChars.test(event.key)) {
        event.preventDefault(); // Bloquea cualquier cosa que no sea número
        }
    }
  }

  onInput(event: Event): void {
    if (this.selectedOption.value === 'phone') {
      // Elimina cualquier carácter que no sea número
      const input = event.target as HTMLInputElement;
      this.inputValue = input.value.replace(/[^0-9]/g, '');
    }
  }

}
